import { render, staticRenderFns } from "./BannerLanguage.vue?vue&type=template&id=40f2142e"
import script from "./BannerLanguage.vue?vue&type=script&lang=js"
export * from "./BannerLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports